import { render, staticRenderFns } from "./DisasterEventNameInput.vue?vue&type=template&id=0f45d06b"
import script from "./DisasterEventNameInput.vue?vue&type=script&lang=js"
export * from "./DisasterEventNameInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports